import { asUtcDate } from "../reports/schedule-sheet";

// One reading of a feed's health, shared by Manage Data > Feeds and > Connect so the two
// never disagree (10-12: Connect said "Connected" while Feeds said the last file was empty).

/** Source checks (discover, preview, key events) never count toward a feed's health. */
export const CHECK_MODES = ["discover", "preview", "key-events"];
export const isCheckRun = r => CHECK_MODES.includes(String(r.mode || "").toLowerCase());
export const isRunning = r => r.success == null && !r.finishedDate;
/** Providers whose runs carry no row counts, so zero counts are not "empty". */
export const COUNTLESS = ["Audience", "Shopify", "HistoricalImport"];
export const isEmptyRun = r => r.success === true && !isCheckRun(r) && !COUNTLESS.includes(r.provider) && !(Number(r.rowsRead) > 0) && !(Number(r.rowsUpserted) > 0) && !(Number(r.rowsDeleted) > 0);
export const periodHours = row => {
  const f = String(row && row.frequency || "").toLowerCase();
  return f === "weekly" ? 168 : f === "monthly" ? 744 : 24;
};

/** The schedule's latest real run (newest first in `runs`), or null. */
export function lastRealRun(schedule, runs) {
  if (!schedule) return null;
  return (runs || []).find(r => String(r.scheduleId) === String(schedule.id) && !isCheckRun(r)) || null;
}

/** state: paused | never | running | failed | empty | overdue | ok */
export function feedHealth(schedule, runs) {
  const run = lastRealRun(schedule, runs);
  if (schedule.status !== "Active") return {
    state: "paused",
    run
  };
  if (!run) return {
    state: "never",
    run
  };
  if (isRunning(run)) return {
    state: "running",
    run
  };
  if (run.success === false) return {
    state: "failed",
    run
  };
  if (isEmptyRun(run)) return {
    state: "empty",
    run
  };
  const done = asUtcDate(run.finishedDate || run.startedDate);
  if (done && Date.now() - done.getTime() > (periodHours(schedule) + 6) * 3600000) return {
    state: "overdue",
    run
  };
  return {
    state: "ok",
    run
  };
}